import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import Translation from '../../../../../common/translation/translation.component';
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { validateEmail } from '../../../../../../utils/validation.utils';
import {
    ORFButton
    , ORFDatePicker
    , OR_RRF_TextArea as TextArea
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_InputField as InputField
} from '../../../../../common/forms/order-request-form.component';
import { Row, Col } from 'react-bootstrap';
import { wirelineTerminateCircuitActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate-circuit.reducer";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../../common/file-attachment/file-attachment.component';
import DATEPICKER_OR from '../../../../../common/custom-form/custom-date-picker.component';
import { MAX_LENGTH, CIRCUIT_STATUS } from '../../../../../../constants/external-constants';
import { ConfirmationNotificationModal } from '../../../../../common/modal/confirmation-modal.component';
import {SUBMIT_REQUEST_TITLE} from "../../../../../../constants/external-constants";
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import { Loading } from '../../../../../common/loading/index';
import { convertUtcToLocalDate } from '../../../../../../utils/helpers.utils';

class WirelineTerminateExhibitA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            terminateDate: '',
            localToggle: false,
            alterToggle: false,
            error: false,
            showConfirmationModal: false,
            show: false,
            isSaving: false,
            isLoading: false,
            title: '',
            message: ''
        }
    }
    async componentDidMount() {
        const { isUpdateRequest, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { requestData } = this.props.requestDetail;
        const { fetchSubscriptionByCircuitCode, fetchSubscriptionByValue, onSubscriptionSelect, setRequestSelectedData } = this.props;
        const circuitCodePropName = 'CircuitCode';

        if (isUpdateRequest) {
            this.setState({ isLoading: true });
            const requestOnBehalf = requestData.RequestedInBeHalfOf || null;
            await fetchSubscriptionByCircuitCode(requestData.Circuit.CircuitCode, circuitCodePropName, requestOnBehalf)
            await setRequestSelectedData();
            this.setState({ isLoading: false })
            return;
        }
        const hasTakeActionSubscription = takeActionCircuitId != null || (takeActionCircuitCode != null && takeActionCircuitCode !== '');

        if (!hasTakeActionSubscription) {
            onSubscriptionSelect('');
            return;
        }

        this.setState({ isLoading: true });

        const subscriptionList = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);
        const selectedSubscription = Array.isArray(subscriptionList)
            ? subscriptionList.find(item => item?.CircuitCode === takeActionCircuitCode && (takeActionCircuitId == null || item?.CircuitId === takeActionCircuitId)) : null;

        if (selectedSubscription) {
            await onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, [selectedSubscription], null, takeActionCircuitId);
        }

        this.setState({ isLoading: false });
    }
 
    componentWillUnmount() {
        this.props.resetFileAttachment();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
        this.props.resetApprover();
    }

    handleSubmitConfirmation = () =>{
        this.setState({showConfirmationModal: true})
    }

    handleConfirmationModal = async (buttonType) =>{        
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.setState({
                isSaving: true,
            });

            this.submitRequest();

        }else{
            this.setState({
                showConfirmationModal: false
            });
        }
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems, uploadFile, saveOrderFile, wirelineTerminateCircuitFormA } = this.props;

        var success = await submitRequest(wirelineTerminateCircuitFormA.terminateDate);
        let resultMessage = success.Message;
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
            this.setState({
                title: "Success",
                isSaving: false
            })

            const { isUpdateRequest } = this.props.createRequest;
            resultMessage = isUpdateRequest ? this.toLocaleLanguage("order_has_been_updated") : this.toLocaleLanguage("order_has_been_submitted");
        }else {
            this.setState({
                title: "Error",
                isSaving: false
            })
            resultMessage = success.Message ? success.Message : this.toLocaleLanguage("order_save_error_message");
        }
        this.setState( prev => ({
            showConfirmationModal: !prev.showConfirmationModal,
            show:true, 
            message: resultMessage,
        }))
        // modalMessage(success);
    }

    handleCloseNotif = () => {
        const { closeAction } = this.props;
        this.setState({ show: false });   
        if(this.state.title!=="Error")
        {
            closeAction();
        } 
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    setTerminateDate = (v) => {
        if(v !== ''){
            this.setState({
                terminateDate: v
            });
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    validateData = () => {
        const { wirelineTerminateCircuitFormA } = this.props;
        const { formSubmitted } = this.props.wirelineTerminateCircuitRequest;
        const { requestOnBehalfData, isRequestOnBehalf, isUpdateRequest } = this.props.createRequest;
        if (!wirelineTerminateCircuitFormA.circuitId || !wirelineTerminateCircuitFormA.wireLineApproverId || !wirelineTerminateCircuitFormA.terminateDate || !wirelineTerminateCircuitFormA.businessJustification || formSubmitted) {
            return true;
        }

        if (isRequestOnBehalf) {
            if (requestOnBehalfData && requestOnBehalfData.EmployeeId > 0 && wirelineTerminateCircuitFormA.circuitCode !== '') {
                if (isUpdateRequest) {
                   return this.isSameParam();
                }
            }
        } else {
            if (isUpdateRequest) {
                return this.isSameParam();
            }
        }
      
        return false;
    }

    isSameParam = () => {  
        const { circuitCode, businessJustification, additionalInformation, wireLineApproverId, terminateDate } = this.props.wirelineTerminateCircuitFormA;
        const { requestData } = this.props.requestDetail;
        let isTermenateDt = (requestData.Order.OrderDisconnectDate ? new Date(convertUtcToLocalDate(requestData.Order.OrderDisconnectDate)) : '').toDateString() === (!terminateDate == false ? terminateDate.toDateString() : '');
  
        let isSame = (requestData.Circuit.CircuitCode === circuitCode
            && requestData.WireLineApprover.EmployeeId === wireLineApproverId
            && requestData.BusinessJustification.BusinessJustification === businessJustification
            && requestData.BusinessJustification.AdditionalInformation === additionalInformation
            && isTermenateDt)
        console.log("IsSameParam " + isSame );
        return isSame
   
    }

    render() {

        const {
            //form
            wirelineTerminateCircuitFormA
            //reducer action
            , onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
        } = this.props;

        const { subscriptionList, employeeList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { formSubmitted, subscription, isResetLoading } = this.props.wirelineTerminateCircuitRequest;
        const { terminateDate, isLoading } = this.state;
        const { requestData } = this.props.requestDetail;
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus 
        : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";
        return isLoading ?
            (<div>
                <Loading />
            </div>) : (
            <div className="wireline-terminate-container">
                  <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal confirmation-blur-background notification-footer modal-text-bold'}
                />
                 <ConfirmationNotificationModal 
                    show={this.state.showConfirmationModal} 
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")} 
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal confirmation-blur-background modal-text-bold'}
                    disabled={this.state.isSaving}
                />

                <Form method="post" role="form"
                    model="wirelineTerminateCircuitFormA"
                    onSubmit={this.handleSubmitConfirmation}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea'>
                           {
                             !isResetLoading &&  <SearchSuggestions
                                value={wirelineTerminateCircuitFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')}`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                errorMessage={this.toLocaleLanguage('error_subscription_not_exist')}
                                haveError={this.haveError}
                            />
                           } 
                            {wirelineTerminateCircuitFormA.circuitCode != '' &&
                               <div className="pb-15-pl-30">
                               <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended"}>{circuitStatusName} </span> <span>| </span>
                               {subscription.VendorName && subscription.VendorName !== "" ? subscription.VendorName : <Translation translationKey="no_vendor" />} <span>| </span>
                               {subscription.CircuitTypeName && subscription.VendorName !== "" ? subscription.CircuitTypeName  : <Translation translationKey="no_circuit_type_available" />} <span>| </span>
                               {subscription.SubCircuitTypeName && subscription.VendorName !== "" ? subscription.SubCircuitTypeName  : <Translation translationKey="no_sub_circuit_type_available" />} 
                           </div>
                            }
                        </Col>
                    </Row>
                    <div className="text-field-container">
                        <span className='text-field-title'>TERMINATE REQUEST DETAILS</span>
                    </div>
                    <Row>
                        <Col xs={6} md={6} lg={6}>
                                <div className={`date-picker-group ${wirelineTerminateCircuitFormA.circuitId === 0 ? "date-picker-wrapper disabled" : ""}`} >
                                <DATEPICKER_OR 
                                    label={`${this.toLocaleLanguage('terminate_date')}`}
                                    subLabel={`${this.toLocaleLanguage('parenthesis_effectivity_date')}` }
                                    startDate={wirelineTerminateCircuitFormA.terminateDate}
                                    selectedDate={(date) => this.props.FormChange("wirelineTerminateCircuitFormA.terminateDate", date)}
                                    isDisable={wirelineTerminateCircuitFormA.circuitId == 0}
                                    minDate={new Date()}
                                    requiredField={true}
                                    placeholder={`${this.toLocaleLanguage('select_date')}`} 
                                /> 
                             </div>                        
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea custom-margin-btm'> {
                              !isResetLoading && <SearchSuggestions
                                    value={wirelineTerminateCircuitFormA.employeeEmail}
                                    label={`${this.toLocaleLanguage('approver')}`}
                                    propDisplay={'LastFirstName'}
                                    options={employeeList.length > 0 ? employeeList : ''}
                                    onChangeAction={onEmployeeSelect}
                                    searchAction={fetchEmployeeByValue}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                             />
                        }
                      
                        </Col>
                    </Row>
                   
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required placeholder-padding-textarea'>
                            <TextArea
                                label={this.toLocaleLanguage('business_justification')}
                                fieldProp='.businessJustification'
                                value={wirelineTerminateCircuitFormA.businessJustification}
                                maxLength={MAX_LENGTH.limit_500}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>
                  
                    <Row>
                        <Col xs={12} md={12} lg={12} className='placeholder-padding-textarea' >
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineTerminateCircuitFormA.additionalInformation}
                                maxLength={MAX_LENGTH.limit_1000}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            />
                        </Col>
                    </Row>

                    <Row>
                    <Col xs={3} md={3} lg={3} >
                        <FileAttachment isUpdate={isUpdateRequest} requestFileName={requestData.Order != undefined ? requestData.Order.OrderFileNames : null}/>
                     </Col>
                    </Row>

                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={this.validateData()}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelineTerminateCircuitRequest, createRequest, translation, requestDetail } = state;
        const { wirelineTerminateCircuitFormA } = state.form;
        return {
            wirelineTerminateCircuitRequest
            , wirelineTerminateCircuitFormA
            , createRequest
            , ...translation
            , requestDetail
        };
    }
    , dispatch =>({
        ...bindActionCreators(
            Object.assign({}, wirelineTerminateCircuitActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
            ),
            dispatch
        ),
        FormChange:(Model, value) =>{
            dispatch(actions.change(Model, value))
        }
    })
       
)(WirelineTerminateExhibitA);